export const saRegionSc = 'SC';
export const saRegionSc24 = 'SC24';
export const saRegionKsa = 'KSA';



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/models/Regions.ts